import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import Emojies from "../Emojies/Emojies";
import RadioGroup from "./RadioGroup/RadioGroup";
import CheckboxesGroup from "./CheckboxesGroup/CheckboxesGroup";
import stl from "./Question.module.css";
var Question = function Question(_ref) {
  var question = _ref.question,
    mainAnswer = _ref.mainAnswer,
    secondaryType = _ref.secondaryType,
    secondaryAnswer = _ref.secondaryAnswer,
    otherDetails = _ref.otherDetails,
    setAnswer = _ref.setAnswer,
    secondaryOptions = _ref.secondaryOptions,
    error = _ref.error,
    setError = _ref.setError,
    isOpen = _ref.isOpen;
  var _useTranslation = useTranslation(["web_survey"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("form", {
    className: stl.form
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.question
  }, question.title), isOpen ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.openQuestWrapper, " ").concat(error && !mainAnswer ? stl.shake : ""),
    onAnimationEnd: function onAnimationEnd(e) {
      return e.target.classList.remove(stl.shake);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(stl.error, " ").concat(stl.openQuestError)
  }, error && error), /*#__PURE__*/React.createElement("textarea", {
    value: otherDetails,
    onChange: function onChange(e) {
      return setAnswer(function (pre) {
        return _objectSpread(_objectSpread({}, pre), {}, {
          otherDetails: e.target.value
        });
      });
    },
    className: "".concat(stl.textarea, " ").concat(stl.openQuestionTextArea, " ").concat(error ? stl.error : ""),
    placeholder: t("write_here", {
      ns: "web_survey"
    }),
    onFocus: function onFocus() {
      return setError("");
    }
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, mainAnswer === "" && /*#__PURE__*/React.createElement(Emojies, {
    options: question.answers,
    mainAnswer: mainAnswer,
    setAnswer: setAnswer,
    error: error,
    setError: setError
  }), error && /*#__PURE__*/React.createElement("span", {
    className: stl.error
  }, error), secondaryOptions.length && secondaryType === "radio" ? /*#__PURE__*/React.createElement(RadioGroup, {
    options: secondaryOptions,
    mainAnswer: mainAnswer,
    secondaryAnswer: secondaryAnswer,
    setAnswer: setAnswer,
    error: error,
    setError: setError
  }) : null, secondaryOptions.length && secondaryType === "checkbox" ? /*#__PURE__*/React.createElement(CheckboxesGroup, {
    options: secondaryOptions,
    mainAnswer: mainAnswer,
    secondaryAnswer: secondaryAnswer,
    setAnswer: setAnswer,
    error: error,
    setError: setError
  }) : null, mainAnswer && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
    className: "\n                  ".concat(stl.label, "\n                   ").concat(secondaryOptions ? "" : stl.mt, "\n                    ")
  }, t("add_details", {
    ns: "web_survey"
  }), /*#__PURE__*/React.createElement("span", null, " ", t("optional", {
    ns: "web_survey"
  }))), /*#__PURE__*/React.createElement("textarea", {
    className: stl.textarea,
    value: otherDetails,
    placeholder: t("write_here", {
      ns: "web_survey"
    }),
    onChange: function onChange(e) {
      return setAnswer(function (pre) {
        return _objectSpread(_objectSpread({}, pre), {}, {
          otherDetails: e.target.value
        });
      });
    }
  }))));
};
export default Question;